import React, { useEffect, useCallback, useState, useRef } from 'react';
import xeroService from '../../../services/xeroService';
import XeroForm from '../../../components/pageModule/Xero/XeroForm';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const XeroSettings = () => {
    const [initialData, setInitialData] = useState({ 
        xero_client_id: '',
        xero_client_secret: '',
        xero_redirect_uri: '',
        xero_status: {
            id: '1',
            label: 'Active'
        }
    });
    const isFetching = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleCreate = async (formData) => {
        try {
            const response = await xeroService.saveSettings(formData);
            toast.success('Xero settings saved successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error saving Xero settings', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        create: handleCreate,
    };

    // Fetch function with proper dependencies using actions
    const fetchData = useCallback(async () => {
        // Prevent multiple calls
        if (isFetching.current) {
            return;
        }
        isFetching.current = true;

        try {
            setIsLoading(true);
            const data = await xeroService.getSettings();
            setInitialData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            isFetching.current = false;
            setIsLoading(false);
        }
    }, []); // Remove actions from dependencies since it's stable

    // Initial data fetch - only run once on mount
    useEffect(() => {
        fetchData();
    }, []);
    
    return (
        <>
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <XeroForm 
                                        initialData={initialData}
                                        onSave={async (data) => {
                                            try {
                                                const response = await actions.create(data);
                                                await fetchData(); // Refresh data after save
                                                return response;
                                            } catch (error) {
                                                console.error('Error creating item:', error);
                                                throw error;
                                            }
                                        }}
                                        onClose={() => {
                                            console.log('cancel btn clicked')
                                        }}
                                        customActionsDispatch={actions}
                                        isLoading={isLoading}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default XeroSettings;